<template>
  <VueApexCharts
    :options="donutOptions"
    :series="donutSeries"
    :total="total"
    class="donut-chart"
  />
</template>

<script>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";
import { getPercent } from "@/modules/number";

export default {
  props: {
    series: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    formatter: {
      type: Function,
      required: false,
    },
    legendOffsetX: {
      type: Number,
      required: false,
      default: 0,
    },
    legendOffsetY: {
      type: Number,
      required: false,
      default: 0,
    },
    tooltipTitleFormatter: {
      type: Function,
      required: false,
      default: () => "",
    },
  },
  components: { VueApexCharts },
  setup(props) {
    const total = computed(() => {
      return props.series.reduce((acc, item) => acc + item, 0);
    });
    const donutSeries = computed(() => {
      return total.value === 0 ? [1] : props.series;
    });
    const donutFormatter = computed(() => {
      const baseFormatter = (seriesName, opts) => {
        const value =
          parseInt(opts.w.globals.series[opts.seriesIndex], 10) || 0;
        const total = opts.w.globals.series
          ? opts.w.globals.series
              .map(function (item) {
                return parseInt(item, 10);
              })
              .reduce((a, b) => a + b)
          : 0;
        const percent = getPercent(value, total);
        const displayValue =
          0 < percent && percent < 1 ? "менее 1" : Math.round(percent);

        return `${displayValue}% — ${seriesName}`;
      };
      const emptyFormatter = (seriesName) => {
        return `% — ${seriesName}`;
      };

      return total.value === 0 ? emptyFormatter : baseFormatter;
    });
    const donutOptions = computed(() => {
      return {
        chart: {
          type: "donut",
          sparkline: {
            enabled: true,
          },
        },
        labels: props.labels,
        tooltip: {
          enabled: total.value !== 0,
          y: {
            title: {
              formatter: props.tooltipTitleFormatter,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          colors: total.value === 0 ? ["#D5D5D5"] : props.colors,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            offsetX: 0,
            offsetY: 0,
            size: 90,
            donut: {
              size: 80,
            },
          },
        },
        legend: {
          show: true,
          floating: true,
          position: "left",
          fontFamily: "Source Sans Pro",
          fontWeight: 300,
          fontSize: "16px",
          offsetX: props.legendOffsetX,
          offsetY: props.legendOffsetY,
          itemMargin: {
            vertical: 4,
          },
          formatter: props.formatter || donutFormatter.value,
          onItemClick: {
            toggleDataSeries: total.value !== 0,
          },
          onItemHover: {
            highlightDataSeries: total.value !== 0,
          },
          markers: {
            fillColors: props.colors,
          },
        },
        stroke: {
          show: false,
        },
        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
          active: {
            filter: {
              type: "none",
            },
          },
        },
      };
    });

    return {
      donutOptions,
      donutSeries,
    };
  },
};
</script>

<style>
.donut-chart .apexcharts-inner {
  transform: translate(0, 0);
}
.donut-chart .apexcharts-legend {
  top: 0 !important;
  bottom: 0 !important;
  display: flex;
  justify-content: center !important;
}
</style>
